import React from "react";
import { useHistory } from "react-router-dom";
import { CUSTOMER_ROUTES } from "pages/routes";
import classNames from "classnames/bind";
import styles from "./styles.module.scss";

const cn = classNames.bind(styles);

interface ITabs {
  active: "calendar" | "standing";
}

/** "Calendar | Standing order". The caller renders it only for enabled schools. */
const StandingOrderTabs: React.FC<ITabs> = ({ active }) => {
  const history = useHistory();
  return (
    <div className={cn("tabs")} role="tablist">
      <button
        type="button"
        role="tab"
        aria-selected={active === "calendar"}
        className={cn("tab", { tab_on: active === "calendar" })}
        onClick={() => active !== "calendar" && history.push(CUSTOMER_ROUTES.ORDER)}
      >
        Calendar
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={active === "standing"}
        className={cn("tab", { tab_on: active === "standing" })}
        onClick={() =>
          active !== "standing" && history.push(CUSTOMER_ROUTES.STANDING_ORDER)
        }
      >
        Standing order
      </button>
    </div>
  );
};

export default StandingOrderTabs;
